import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import MAliasesTab from './components/molecules/MAliasesTab/AliasView';
import FacultativeTab from './components/molecules/FacultativeTab/FacultativeView';
import MProductTitleTab from './components/molecules/MProductTitleTab/ProductTitleView';

const ProductTitlesTabs = ({ setTabIndex, index }: any) => {
    const translate = useTranslation();

    return (
        <Tabs size="sm" isLazy onChange={(index) => setTabIndex(index)} index={index}>
            <TabList>
                <Tab display="none" />{' '}
                {/* Add empty tab because we merged two pages,
                the real first tab is the tab on the other page (product-management) */}
                <Tab _focus={{ boxshadow: 'none' }}>{translate('splits.tab.titles')}</Tab>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('splits.tab.aliases')}</Tab>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('splits.tab.facultative')}</Tab>
            </TabList>
            <TabPanels>
                <TabPanel /> {/* Add empty panel for the same reason then above */}
                <TabPanel>
                    <MProductTitleTab />
                </TabPanel>
                <TabPanel>
                    <MAliasesTab />
                </TabPanel>
                <TabPanel>
                    <FacultativeTab />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
};

export default ProductTitlesTabs;
